var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStatus21(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.152,
    height: 143.28,
    viewBox: "0 0 167.152 143.28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_50",
    "data-name": "Group 50",
    transform: "translate(-69.399 -148.598)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "shop",
    transform: "translate(69.399 148.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M34.048,36.431A3.046,3.046,0,0,1,31,33.381V24.709a3.049,3.049,0,0,1,6.1,0v8.672A3.046,3.046,0,0,1,34.048,36.431Z",
    transform: "translate(29.984 18.45)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M39,45.5H63.394V72.942H39Z",
    transform: "translate(46.38 67.301)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M39,36.5H63.394V63.942H39Z",
    transform: "translate(46.38 48.857)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M17,36.5H71.887V66.991H17Z",
    transform: "translate(1.296 48.857)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M22,9.5H82.986V49.143H22Z",
    transform: "translate(11.542 -6.465)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M128.873,25.5v6.092H13V25.5H128.873Z",
    transform: "translate(-6.901 26.324)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M139.07,36.648H11L17.1,27.5H132.971Z",
    transform: "translate(-11 30.418)",
    fill: "#766a6a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M139.07,30.5v6.092H11V30.5Z",
    transform: "translate(-11 36.566)",
    fill: "#504242"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M77.035,90.434H25.2v9.148H13V32.5H128.873V99.582h-12.2V44.7H92.281V99.582h-12.2V90.434Zm3.049-15.246V44.7H25.2V75.188Z",
    transform: "translate(-6.901 40.66)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M18.2,51.5H72.912a1.529,1.529,0,0,1,1.525,1.525v6.1a1.529,1.529,0,0,1-1.525,1.525H18.025A1.529,1.529,0,0,1,16.5,59.121v-6.1A1.529,1.529,0,0,1,18.025,51.5Z",
    transform: "translate(0.271 79.597)",
    fill: "#4c535c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M85.042,54.239H24.047A3.046,3.046,0,0,1,21,51.19V11.555a3.046,3.046,0,0,1,3.049-3.049H85.042a3.046,3.046,0,0,1,3.049,3.049V51.19A3.046,3.046,0,0,1,85.042,54.239ZM27.1,48.141h54.9V14.6H27.1Z",
    transform: "translate(9.489 -8.506)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M72.912,69.536H18.025A1.523,1.523,0,0,1,16.5,68.011V37.519a1.527,1.527,0,0,1,1.525-1.525H72.912a1.527,1.527,0,0,1,1.525,1.525V68.011A1.523,1.523,0,0,1,72.912,69.536ZM19.549,66.487H71.387V39.043H19.549Z",
    transform: "translate(0.271 47.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M64.419,93.93H40.025A1.523,1.523,0,0,1,38.5,92.406V37.519a1.527,1.527,0,0,1,1.525-1.525H64.419a1.527,1.527,0,0,1,1.525,1.525V92.406A1.523,1.523,0,0,1,64.419,93.93Zm-22.87-3.049H62.894V39.043H41.549Z",
    transform: "translate(45.355 47.825)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M64.419,48.043H40.025a1.525,1.525,0,1,1,0-3.049H64.419a1.525,1.525,0,1,1,0,3.049Z",
    transform: "translate(45.355 66.268)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M125.818,30.6H16.05a3.049,3.049,0,1,1,0-6.1H125.818a3.049,3.049,0,0,1,0,6.1Z",
    transform: "translate(-6.899 24.266)",
    fill: "#e6e9ed"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M157.077,59.593H2.493a3.111,3.111,0,0,1,0-6.1H157.077a3.111,3.111,0,0,1,0,6.1Z",
    transform: "translate(2.041 83.687)",
    fill: "#656d78"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M224.917,240l-.911,12.8c-.011.242.181.476.533.648a3.088,3.088,0,0,0,1.331.265h1.743a3.088,3.088,0,0,0,1.331-.265c.351-.172.544-.406.533-.648l-.911-12.8Z",
    transform: "translate(-84.398 -63.308)",
    fill: "#8e1717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M203.648,48.625V45.889L200,44.977S200.912,24,207.3,24V48.625Z",
    transform: "translate(-63.129 128.067)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M80.917,176l-.911,20.8a.972.972,0,0,0,.533.825,2.533,2.533,0,0,0,1.331.337h1.742a2.533,2.533,0,0,0,1.331-.337.972.972,0,0,0,.533-.825L84.565,176Z",
    transform: "translate(44.376 -6.942)",
    fill: "#8e1717"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M72.148,24a.933.933,0,0,0-.852.941v9.09H69.472V24.943A.933.933,0,0,0,68.621,24a.912.912,0,0,0-.973.91v9.121H65.824v-9.09A.933.933,0,0,0,64.972,24a.912.912,0,0,0-.972.91V36.464a3.648,3.648,0,0,0,.73,2.189l2.007,2.675h3.648l2.007-2.675a3.648,3.648,0,0,0,.73-2.189V24.911a.912.912,0,0,0-.972-.91Z",
    transform: "translate(58.557 127.729)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "walk",
    transform: "translate(56.164 214.522)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7461",
    "data-name": "Path 7461",
    d: "M177.956,73.961a7.854,7.854,0,0,1,4.881-.889,3.81,3.81,0,0,1,1.775.27v-.2a8.561,8.561,0,0,1-1.2-7.124l0-.414-1.549-2.542L182,61.553a1.645,1.645,0,0,0-1.642-1.8l-1.472,0s-4.671-1.1-7.371-3.185h-.146a19.307,19.307,0,0,0-.826,4.6l-1,2.353a.705.705,0,0,0,.454.952c.4.18,1.58.138,1.787,1.246.227,1.219.927,3.454,3.026,3.754C176.872,69.778,177.841,71.943,177.956,73.961Z",
    transform: "translate(-18.548 -48.028)",
    fill: "#edcab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7463",
    "data-name": "Path 7463",
    d: "M208.188,163.288s-4.83-.8-6.591,2.8c-1.558,3.183-3.088,11.514-1.691,17.788h8.823Z",
    transform: "translate(-43.899 -138.554)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7464",
    "data-name": "Path 7464",
    d: "M319.586,414.509l-2.565-1.161-4.239,5.685c0,3.139,1.429,6.238,3.2,7.322a1.573,1.573,0,0,0,2.392-1.2l2.182-8.861A1.68,1.68,0,0,0,319.586,414.509Z",
    transform: "translate(-140.187 -350.898)",
    fill: "#010300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7466",
    "data-name": "Path 7466",
    d: "M243.668,326.56a2.4,2.4,0,0,1-1.1-2.326,11.67,11.67,0,0,0-1.527-7.064l-.241.147a13.97,13.97,0,0,1-4.045,7.729,2.533,2.533,0,0,0-.839,1.9v3.632l10.122,6.592a1.782,1.782,0,0,0,2.461-.512l3.269-4.961Z",
    transform: "translate(-74.931 -269.251)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7468",
    "data-name": "Path 7468",
    d: "M186.588,298.961h-4.227c-1.8,4.567-3.908,6.959-3.6,11.421l.986,14.544h7.936V311.647a2.591,2.591,0,0,1,.873-1.933c3.926-3.5,4.248-9.4,4.248-9.4C188.5,299.288,187.933,298.961,186.588,298.961Z",
    transform: "translate(-26.387 -253.793)",
    fill: "#6d8aa2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7470",
    "data-name": "Path 7470",
    d: "M153.358,469.785a7.625,7.625,0,0,0-5.638,4.5,1.492,1.492,0,0,0,1.746,1.861l11.118-.054c.752-.064.951-.651.951-1.443l-.241-4.863Z",
    transform: "translate(0 -398.809)",
    fill: "#010300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7472",
    "data-name": "Path 7472",
    d: "M204.833,218.734c.084-1.333.149-4.791-.88-7.014l-5.909.514a26.553,26.553,0,0,0,.911,6.994,1.813,1.813,0,0,1-.235,1.543c-5.522,8.2-4.741,7.57-5.235,7.848l-2.344,1.322a1.22,1.22,0,0,0-.475,1.641h0a.816.816,0,0,1-.086.9,2.176,2.176,0,0,0,.709,3.269h0a3.047,3.047,0,0,0,3.969-1.053c1.6-2.49,1.673-2.71,2.231-3.131,1.259-.951,5.111-4.143,6.593-8.63a12.138,12.138,0,0,1,.464-1.213C205.115,220.473,204.764,219.825,204.833,218.734Z",
    transform: "translate(-36.056 -179.733)",
    fill: "#edcab0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7474",
    "data-name": "Path 7474",
    d: "M263.751,171.587l-.269-3.088A3.857,3.857,0,0,0,261,165.233a3.958,3.958,0,0,0-1.393,3.387c.388,3.692.187,3.846.555,4.189l2.768-.241A.906.906,0,0,0,263.751,171.587Z",
    transform: "translate(-95.03 -140.269)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7475",
    "data-name": "Path 7475",
    d: "M240.462,171.354a.665.665,0,0,1-.707-.619l-.3-3.487a3.71,3.71,0,0,1,1.457-3.3,3.7,3.7,0,0,0-5.283,3.632l.3,3.487a.679.679,0,0,0,.735.617l5.909-.514Z",
    transform: "translate(-74.674 -138.871)",
    fill: "#d81212"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7476",
    "data-name": "Path 7476",
    d: "M183.336,1.989S176.767-3,170.954,2.818c-5.866,5.866,7.774,9.071,7.774,9.071l1.472,0a1.645,1.645,0,0,1,1.642,1.8,2.962,2.962,0,0,0,.212,2.087l1.355,2.224C193.5,7.139,183.336,1.989,183.336,1.989Z",
    transform: "translate(-18.542 0)",
    fill: "#010300"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus21);
export default __webpack_public_path__ + "static/media/status-21.da6ec1c265717a8c975a0d8677e5a773.svg";
export { ForwardRef as ReactComponent };